<template>
  <div class="popup">
    <div v-if="feedbackGiven" class="thankyou-section">
      <div>
        <Thumbs-up-icon class="thanks-icon"></Thumbs-up-icon>
        <p class="thanks-msg">Thank you for writing.</p>
      </div>
      <span class="fn-14 width-100">
        We really appreciate your feedback and your perspective.
      </span>
      <!-- <span class="fn-12 width-100">With love from Adapt</span> -->
      <button class="but" @click="close()">ok</button>
    </div>
    <div v-else>
      <div
        contenteditable="true"
        class="feedback-hldr"
        id="_feedback_dom"
        placeholder="Feedback about Prospector?"
      ></div>
      <button class="float-l" @click="close()">Cancel</button>
      <button class="float-r but" @click="sendFeedback()">Send feedback</button>
    </div>
  </div>
</template>

<script>
import sharedFunction from '@/assets/util/functions.js'
import positiveVoteIcon from '@/assets/icons/svg/positive-vote.svg'
export default {
  name: 'Feedback-Form',
  props: ['text', 'data'],
  data: function() {
    return {
      feedbackGiven: false
    }
  },
  components: {
    'Thumbs-up-icon': positiveVoteIcon
  },
  methods: {
    sendFeedback() {
      const feedbackDom = document.querySelector('#_feedback_dom')
      const dataMap = { text: feedbackDom.innerText }
      sharedFunction.track(
        'AP - Product Feedback Given',
        dataMap,
        this.$store.state
      )
      this.feedbackGiven = true
      setTimeout(function() {
        this.feedbackGiven = false
        this.close()
      }, 2000)
    },
    close() {
      this.$emit('close', true)
    }
  },
  created() {
    setTimeout(function() {
      const ele = document.querySelector('#_feedback_dom')
      if (ele) {
        ele.focus()
      }
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 25%;
  width: 92%;
  margin: 5%;
  z-index: 2;
  background: #fff;
  padding: 10px 2%;
  border-radius: 5px;
  .feedback-hldr {
    outline: none;
    border: 1px solid #cecece;
    margin-bottom: 10px;
    margin-top: 0px;
    padding: 8px;
    border-radius: 5px;
    font-size: 12px;
    overflow-y: auto;
    height: 25vh;
    box-shadow: 0px 3px 6px 3px #cecece;
  }
  [placeholder]:empty::before {
    content: attr(placeholder);
    color: #cecece;
  }
  .thanks-icon {
    width: 50px;
    height: 50px;
    position: absolute;
    top: -22%;
    left: 40%;
  }

  .thankyou-section {
    text-align: center;
    .thanks-msg {
      text-align: center;
      font-size: 18px;
      margin: 0;
      padding: 15px 8px 0px 8px;
    }
    span {
      text-align: center;
      width: 100%;
      display: block;
      padding: 10px 0px;
      line-height: 20px;
      color: #787878;
    }
    button {
      padding: 8px 20px;
    }
  }
}
</style>
